import { FC } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { LessonContent } from '../components/LessonContent';
import { LessonSummary } from '@/components/lessons/LessonSummary';
import { useLessonProgress } from '@/hooks/useLessonProgress';
import { motion } from 'framer-motion';

const LessonPage: FC = () => {
  const { lessonId } = useParams();
  const navigate = useNavigate();
  const {
    progress,
    isLoading,
    showSummary,
    summaryData,
    setShowSummary,
    updateProgress,
    resetProgress
  } = useLessonProgress(lessonId || '');

  if (!lessonId) {
    return <div>Lección no encontrada</div>;
  }

  // Manejar el cierre del resumen
  const handleSummaryClose = () => {
    setShowSummary(false);
    // Solo redirigir después de que el usuario cierre el resumen
    navigate('/lessons');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4 py-8">
        <LessonContent lessonId={lessonId} />

        {/* Mostrar resumen cuando la lección se completa */}
        {showSummary && summaryData && (
          <LessonSummary
            isOpen={showSummary}
            onClose={handleSummaryClose}
            points={summaryData.points}
            activitiesCompleted={summaryData.activitiesCompleted}
            cerebrixEarned={summaryData.cerebrixEarned}
          />
        )}
      </div>
    </div>
  );
};

export default LessonPage;